import { ReactNode } from 'react'
import Sidebar from './Sidebar'

interface LayoutProps {
  children: ReactNode
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="main-content">
        {children}
      </div>
    </div>
  )
}

export default Layout


